import { apiKeyClient } from "@better-auth/api-key/client";
import { passkeyClient } from "@better-auth/passkey/client";
import {
  magicLinkClient,
  organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const bearAuthClient = createAuthClient({
  plugins: [
    organizationClient(),
    passkeyClient(),
    apiKeyClient(),
    magicLinkClient(),
  ],
});
